module.exports = __webpack_public_path__ + "img/logo49.80b33e3b.png";